<template>
<v-card>
  <v-card-text>
    <selected-appointments-preview v-if='multiple'
      :appointment-ids='appointmentIds'
      class='mb-2' flat >
    </selected-appointments-preview>
    <v-subheader class='ml-3'>{{ $t('text.label') }}</v-subheader>
    <v-alert
      :value='successMessage' color='success' type='success' dismissible class='mb-4' >
      {{ $t('messages.success') }}
    </v-alert>
    <v-alert
      :value='errorMessage' color='success' type='error' dismissible class='mb-4' >
      {{ $t('messages.error') }}
    </v-alert>

    <v-text-field
      :hint='$t("text.hint")'
      persistent-hint
      solo v-model='text' prepend-icon="tag" ></v-text-field>
    <template v-for='(tag, index) in tags' >
      <v-chip
        v-if='tag'
        :key='`${tag}-${index}`'
        color='primary'
        dark
        @input='remove(tag)'
        small close >
        {{tag}}
      </v-chip >
    </template>
  </v-card-text>
  <v-card-actions >
    <v-btn flat @click='$emit("close")' >
      {{ $t('buttons.done') }}
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn color='primary'
      :loading='addRequest.loading'
      :disabled="!isValid" @click='save' >{{ $t('buttons.save') }}</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import SelectedAppointmentsPreview from '@/components/appointment/SelectedAppointmentsPreview'

export default {
  name: 'TagIt',
  components: {SelectedAppointmentsPreview},
  props: {
    appointmentIds: { type: Array, default: () => { return [] } },
    originalTags: { type: Array, default: () => { return [] } },
    multiple: { type: Boolean, default: false },
    touch: { type: Number, default: 2 }
  },
  data () {
    return {
      text: '',
      tags: [],
      requests: {
        add: 'appointment-add-tags-request',
        remove: 'appointment-remove-tags-request'
      },
      successMessage: false,
      errorMessage: false
    }
  },
  mounted () {
    this.text = this.originalTags.join(',')
  },
  watch: {
    originalTags () {
      this.tags = this.originalTags
    },
    text () {
      this.tags = this.text.split(',')
    },
    touch () {
      this.reset()
    },
    addRequestStatus () {
      if (this.addRequestStatus === 200) {
        this.successMessage = true
        this.errorMessage = false
      }
      if (this.addRequestStatus > 299) {
        this.successMessage = false
        this.errorMessage = true
      }
    }
  },
  methods: {
    reset () {
      this.successMessaage = false
    },
    save () {
      let data = {
        appointments: this.appointmentIds.join(','),
        tags: this.tagsText
      }
      this.$appointmentguru
        .resource('appointment.tags')
        .id(this.requests.add)
        .create(data)
    },
    remove (tag) {
      let rawText = this.text.replace(tag, '')
      let tags = rawText.split(',').filter((tag) => {
        return (tag)
      })
      this.text = tags.join(',')
    }
  },
  computed: {
    addRequest () {
      return this.$store.getters.getRequestById(this.requests.add, true)
    },
    addRequestStatus () {
      return this.addRequest.status
    },
    isValid () {
      if (this.tags) {
        if (this.tags.length === 1 && this.tags[0] === '') { return false }
        return true
      }
      return false
    },
    tagsText () {
      return this.tags.join(',')
    }
  },
  i18n: {
    messages: {
      en: {
        buttons: {
          save: 'Add tags'
        },
        text: {
          label: 'Type tags to add',
          hint: 'Split new tags with a comma'
        },
        messages: {
          success: 'Successfully added tags',
          error: 'There was a problem adding your tabs. Please try again'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Tag.vue?08135aab